import classNames from 'classnames';
import map from 'lodash/map';
import moment from 'moment';
import numeral from 'numeral';
import {PropTypes} from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchStatsLeaguesRestart} from '../../../../../actions/entities/statistics/leagues';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import Loader from '../../../../../components/Loader';

const month = moment().month();
const year = moment().year();

// Si on est en août ou plus la saison est l'année en cours.
// Année en cours = 2018
// Si mois < août Alors saison = 2017 Sinon saison = 2018
const currentSeason = month >= 7 ? year : year - 1;

class LeaguesRestartWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {season: props.currentSeason, lang: 'ALL'};
  }

  fetchStats() {
    const {season} = this.state;
    const {isFetching} = this.props.restarted;
    if (!isFetching) {
      this.props.dispatch(
        fetchStatsLeaguesRestart(
          {
            season,
          },
          null,
          (type, error) =>
            swal({
              title: `Oops...`,
              type: 'error',
              html:
                `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
                `<pre><code>${JSON.stringify(
                  error,
                  undefined,
                  4,
                )}</code></pre>`,
            }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  static renderRow(name, count, type) {
    const percent = (type[name] / count) * 100;

    return (
      <tr key={`${name}`}>
        <td style={{width: '150px '}}>Ligue de {name}</td>
        <th>{numeral(count).format('0,0')}</th>
        <th>{numeral(type[name]).format('0,0')}</th>
        <td className="text-center">{numeral(percent).format('0')} %</td>
      </tr>
    );
  }

  static orderTable(table) {
    // No order for this widget
    return table;
  }

  renderTable(table, type) {
    if (!table) return false;

    return (
      <div className="mt-3 table-responsive">
        <table className="table table-striped">
          <thead>
            <tr className="bg-gray">
              <th>Mode</th>
              <th>Finished</th>
              <th>Restarted</th>
              <th className="text-center">%</th>
            </tr>
          </thead>
          <tbody>
            {map(table, (value, modeName) => {
              return (
                <tr>
                  <td style={{width: '150px '}}>{modeName}</td>
                  <th>{numeral(value.finished).format('0,0')}</th>
                  <th>{numeral(value.restarted).format('0,0')}</th>
                  <td className="text-center">
                    {numeral((value.restarted / value.finished) * 100).format(
                      '0,0',
                    )}{' '}
                    %
                  </td>
                </tr>
              );
            })}
            {/* {map(table.finished, (count, name) =>
              LeaguesRestartWidget.renderRow(name, count, table[type]),
            )}
            <tr>
              <td style={{width: '150px '}}>Total</td>
              <th>{numeral(sumOfCountFinished).format('0,0')}</th>
              <th>{numeral(sumOfCountRestarted).format('0,0')}</th>
              <td className="text-center">
                {numeral(
                  (sumOfCountRestarted / sumOfCountFinished) * 100,
                ).format('0,0')}{' '}
                %
              </td>
            </tr> */}
          </tbody>
        </table>
      </div>
    );
  }

  renderLeagueRestartByPlayersCount() {
    const {data, isFetching} = this.props.restarted;
    const {lang} = this.state;
    const table = data && data[lang];

    return (
      !isFetching &&
      table && <div className="mb-4">{this.renderTable(table)}</div>
    );
  }

  render() {
    const {lang} = this.state;
    const season = parseInt(this.state.season, 10);

    const isFetchingRestarted = this.props.restarted.isFetching;

    const seasonOptions = [];
    for (let i = parseInt(this.props.currentSeason, 10); i >= 2017; i--) {
      seasonOptions.push(
        <option key={i} value={i}>
          Saison {i} - {i + 1}
        </option>,
      );
    }

    return (
      <div id="leaguesRestart-stats-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-retweet" /> Nombre de relance de ligue
            </h3>
            <br />
            Nombre de ligue relancée sur la saison en cours ({season} -{' '}
            {season + 1})
          </div>
          <div className="box-body">
            <div className="text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <select
                style={{width: '200px'}}
                className="inline form-control"
                value={season}
                onChange={e => this.setState({season: e.target.value})}>
                {seasonOptions}
              </select>
              <button
                className="ml-2 inline btn btn-default"
                onClick={() => this.fetchStats()}>
                <i className="fa fa-refresh" />
              </button>
            </div>
          </div>
          {isFetchingRestarted && <Loader />}
          {this.renderLeagueRestartByPlayersCount()}
        </div>
      </div>
    );
  }
}

LeaguesRestartWidget.propsType = {
  currentSeason: PropTypes.string,
};

LeaguesRestartWidget.defaultProps = {
  currentSeason,
};

export default connect(
  state => ({
    restarted: state.app.statistics.leaguesRestart,
  }),
  dispatch => ({dispatch}),
)(LeaguesRestartWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/LeaguesRestart/index.js